// src/app/shared/services/archive-hunt-template.guard.ts
import { Injectable, inject } from '@angular/core'
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router'
import { catchError, map, Observable, of } from 'rxjs'

import { HuntTemplateService } from '../shared/services'

@Injectable({ providedIn: 'root' })
export class ArchiveHuntTemplateGuard implements CanActivate {
  private readonly router = inject(Router)
  private readonly service = inject(HuntTemplateService)

  canActivate(route: ActivatedRouteSnapshot): boolean | Observable<boolean> {
    const id = route.paramMap.get('huntTemplateId')
    if (!id) {
      // no template‐ID → bounce back to template list
      this.router.navigate(['/hunt', 'hunt-template'])
      return false
    }

    return this.service.getHuntTemplateById(id).pipe(
      map((tpl) => {
        if (tpl.archived) {
          // archived → send to the same archive‐gate
          this.router.navigate(['/hunt', 'archive-gate'])
          return false
        }
        return true
      }),
      catchError(() => {
        // on error, drop into the gate as well
        this.router.navigate(['/hunt', 'archive-gate'])
        return of(false)
      }),
    )
  }
}
